import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_ERROR,
  REGISTER_USER,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_ERROR,
  LOGOUT_USER,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  // RESET_PASSWORD,
  // RESET_PASSWORD_SUCCESS,
  // RESET_PASSWORD_ERROR,
  GET_DATA_FROM_TOKEN,
  CHANGE_SPA,
  CHANGE_USER_IMAGE,
  CHANGE_USER_USERNAME,
  CHANGE_SPA_DETAIL_BY_COMPANY_DETAIL,

  LOAD_NOTIFY,
  LOAD_NOTIFY_SUCCESS,
} from '../actions';
// import { getCurrentUser } from '../../helpers/Utils';
// import { isAuthGuardActive, currentUser } from '../../constants/defaultValues';
// let spaIDValidate = null
// let roleManagementValidate = null
// let CurrentSpaValidate = null
// spa_used
const INIT_STATE = {
  user: '',
  user_id: '',
  userImage: '',
  name: '',
  spa_id: '',
  token: localStorage.getItem("token"),
  roleManagement: {
    roleDashboard: { view: false, add: false, delete: false },
    dashboardType : 'STAFF' ,
    roleReport: { view: false, add: false, delete: false },
    roleBooking: { view: false, add: false, delete: false },
    rolePointofSale: { view: false, add: false, delete: false },
    roleFinancial: { view: false, add: false, delete: false },
    roleHousekeeping: { view: false, add: false, delete: false },
    roleQueue: { view: false, add: false, delete: false },
    roleInventory: { view: false, add: false, delete: false },
    roleSetting: { view: false, add: false, delete: false },
    settingTreatmentManagement: false,
    settingPackageManagement: false,
    settingCustomerManagement: false,
    settingPromotionManagement: false,
    settingStaffManagement: false,
    settingServiceFeeManagement: false,
    settingBedManagement: false,
    settingMembershipManagement: false,
    settingUserManagement: false,
    settingInventoryManagement: false,
    settingCouponManagement: false,
  },
  spa: [],
  currentSpa: null,
  loading: false,
  loadingNotify: false,
  forgotUserMail: "",
  exp: 0,
  alertErrorLogin: false,
  error: '',
  notify: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return { ...state, loading: true, error: '' };
    case LOGIN_USER_SUCCESS: {
      localStorage.setItem('spa_used', action.payload.spa_id)
      // console.log("Dogg", action.payload.spa.find(item => item.id_spa === action.payload.spa_id))
      // console.log(action.payload.spa)
      return {
        ...state,
        loading: false,
        user: action.payload.userName,
        name: action.payload.name,
        user_id: action.payload.user_id,
        userImage: action.payload.userImage,
        token: action.payload.accessToken,
        roleManagement: action.payload.roleManagement,
        spa_id: action.payload.spa_id,
        spa: action.payload.spa,
        currentSpa: action.payload.spa.find(item => item.id_spa === action.payload.spa_id),
        exp: action.payload.expConfirm,
      };
    }
    case LOGIN_USER_ERROR:
      return {
        ...state,
        loading: false,
        currentUser: null,
        error: action.payload,
      };
    case FORGOT_PASSWORD:
      return { ...state, loading: true, error: '' };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        forgotUserMail: action.payload,
        error: '',
      };
    case FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        loading: false,
        forgotUserMail: '',
        error: action.payload,
      };
    case GET_DATA_FROM_TOKEN: {
      const spaUsed = localStorage.getItem("spa_used")
      let spaIDValidate = action.payload.spa_id || state.spa_id;
      let roleManagementValidate = action.payload.roleManagement || state.roleManagement
      let CurrentSpaValidate = action.payload.spa.find(item => item.id_spa === action.payload.spa_id)
      if (spaUsed) {
        const CurrentSpaValidateBySpaUsed = action.payload.spa.find(item => item.id_spa === spaUsed)
        if (CurrentSpaValidateBySpaUsed && CurrentSpaValidateBySpaUsed.suspended === 0) {
          spaIDValidate = CurrentSpaValidateBySpaUsed ? spaUsed : action.payload.spa_id
          CurrentSpaValidate = CurrentSpaValidateBySpaUsed || action.payload.spa.find(item => item.id_spa === action.payload.spa_id)
          roleManagementValidate = CurrentSpaValidateBySpaUsed ? CurrentSpaValidateBySpaUsed.roleManagement : action.payload.roleManagement
        }
      }
      return {
        ...state,
        loading: false,
        user: action.payload.userName,
        name: action.payload.name,
        user_id: action.payload.user_id,
        userImage: action.payload.userImage,
        token: action.payload.accessToken,
        roleManagement: roleManagementValidate,
        spa_id: spaIDValidate,
        spa: action.payload.spa,
        currentSpa: CurrentSpaValidate,
        exp: action.payload.expConfirm,
      };
    }
    case CHANGE_SPA:
      return {
        ...state,
        loading: false,
        roleManagement: action.payload.roleManagement,
        spa_id: action.payload.spa_id,
        currentSpa: action.payload.currentSpa,
      };
    case CHANGE_USER_IMAGE:
      return {
        ...state,
        loading: false,
        userImage: action.payload.userImage,
      };
    case CHANGE_USER_USERNAME:
      return {
        ...state,
        loading: false,
        name: action.payload.newUserName,
      };
    case CHANGE_SPA_DETAIL_BY_COMPANY_DETAIL: {
      const oldCurrentSpa = state.currentSpa
      const newCurrentSpa = {
        ...oldCurrentSpa,
        logo_spa_url: action.payload.newSpaLogo,
        name_spa: action.payload.newSpaName,
        name_spa_en: action.payload.newSpaNameEN,
      }
      return {
        ...state,
        loading: false,
        currentSpa: newCurrentSpa,
      };
    }
    case LOAD_NOTIFY:
      return { ...state, loading: true, loadingNotify: true, error: '' };
    case LOAD_NOTIFY_SUCCESS:
      return {
        ...state,
        loading: false,
        loadingNotify: false,
        notify: action.payload
      }
    // case RESET_PASSWORD:
    //   return { ...state, loading: true, error: '' };
    // case RESET_PASSWORD_SUCCESS:
    //   return {
    //     ...state,
    //     loading: false,
    //     newPassword: action.payload,
    //     resetPasswordCode: '',
    //     error: '',
    //   };
    // case RESET_PASSWORD_ERROR:
    //   return {
    //     ...state,
    //     loading: false,
    //     newPassword: '',
    //     resetPasswordCode: '',
    //     error: action.payload.message,
    //   };
    case REGISTER_USER:
      return { ...state, loading: true, error: '' };
    case REGISTER_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        currentUser: action.payload,
        error: '',
      };
    case REGISTER_USER_ERROR:
      return {
        ...state,
        loading: false,
        currentUser: null,
        error: action.payload.message,
      };
    case LOGOUT_USER:
      return {
        ...state,
        user: '',
        user_id: '',
        name: '',
        userImage: '',
        spa_id: '',
        spa: [],
        token: null,
        roleManagement: {
          roleDashboard: { view: false, add: false, delete: false },
          dashboardType : 'STAFF' ,
          roleReport: { view: false, add: false, delete: false },
          roleBooking: { view: false, add: false, delete: false },
          rolePointofSale: { view: false, add: false, delete: false },
          roleFinancial: { view: false, add: false, delete: false },
          roleHousekeeping: { view: false, add: false, delete: false },
          roleQueue: { view: false, add: false, delete: false },
          roleInventory: { view: false, add: false, delete: false },
          roleSetting: { view: false, add: false, delete: false },
          settingTreatmentManagement: false,
          settingPackageManagement: false,
          settingCustomerManagement: false,
          settingPromotionManagement: false,
          settingStaffManagement: false,
          settingServiceFeeManagement: false,
          settingBedManagement: false,
          settingMembershipManagement: false,
          settingUserManagement: false,
          settingInventoryManagement: false,
          settingCouponManagement: false,
        },
        loading: false,
        exp: 0,
        alertErrorLogin: false,
        currentSpa: null,
        error: '',
        notify: [],
      };
    default:
      return { ...state };
  }
};
